angular.module('cvsApp').service('suspendAccountService', [
  'networkService',
  'xdrService',
  'configManager',
  'suspendAccountModel',
  'cvsAppData',
  function(NS, XS, CM, SAM, CAD) {
    function suspendAccount() {
      this.suspendAccount = function(callBackSuccess, oSuspendAccount) {
        // get url
        //var tokenId = CAD.getTokenId();
        //  var tokenType = CAD.getTokenType();
        var apikey = CAD.getApiKey();
        var params = '&tokenType=SuperUser&tokenID=' + oSuspendAccount.tokenID + '&privateGUID=' + oSuspendAccount.privateGUID;
        var url = CM.getApiUrlWithApikeyAndAppName('SUSPEND_ACCOUNT', 'Portal') + params;

        if (url === 'URL_ERROR') {
        } else {
          var plainUrl = CM.getPlainApiUrl(url);
          //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
          var request = {
            url: plainUrl,
            data: getRequestBody(url),
            header: {
              'Content-Type': 'application/json',
              accept: 'application/xml'
            },
            onSuccess: callBackSuccess
          };

          cvsUtility.commonServiceCode(plainUrl, 'suspendAccount', SAM, request, callBackSuccess, NS);
        }
      };

      var getRequestBody = function(entities) {
        var requestJson = { serviceParams: CM.getModifiedParams(entities) };
        return requestJson;
      };
    }

    return new suspendAccount();
  }
]);
